module.exports = __webpack_public_path__ + "img/img1.dc27c116.png";